import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SignInComponent} from './sign-in/sign-in.component';
import {SharedModule} from '../shared/shared.module';
import {PublicRoutingModule} from './public-routing.modules';
import {AuthenticatedUserComponent} from './authenticated-user/authenticated-user.component';
import {ErrorComponent} from './error/error.component';
import {SignOutComponent} from './sign-out/sign-out.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    SignInComponent,
    SignOutComponent,
    ErrorComponent,
    AuthenticatedUserComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    PublicRoutingModule,
    MatProgressSpinnerModule
  ]
})
export class PublicModule {
}
